<template>
    <el-dialog
            :visible.sync="dialogVisible"
            :modal="false"
            width="50%" height="65%">
        <template>
            <div>
                <hos-apply-title title="病情资料"></hos-apply-title>
                <el-form :model="form" class="mt20" label-position="left" label-width="80px" size="mini">
                    <el-form-item label="主诉:">
                        <v-textarea placeholder="请输入主诉" :readonly=true
                                    v-model="form.consultContent"></v-textarea>
                    </el-form-item>
                    <el-form-item label="初步诊断:">
                        <v-textarea placeholder="请输入初步诊断" :readonly=true
                                    v-model="form.beforeDiagnose" :maxlength="100"></v-textarea>
                    </el-form-item>
                    <el-form-item>
                        <div class="" slot="label" style="line-height: 20px">申请会诊目的（或事由）：</div>
                        <v-textarea :readonly=true v-model="form.consultReason"
                                    placeholder="请输入申请会诊目的（或事由）" :maxlength="50"></v-textarea>
                    </el-form-item>
                    <el-form-item label="病历附件：" label-width="80px">
                        <concul-file :picList="form.picList" :filelist="form.attaList" :type="form.status" ref="load" from="accept"></concul-file>
                    </el-form-item>
                </el-form>

            </div>

        </template>
    </el-dialog>
</template>

<script>
  import hosApplyTitle from "../../components/hos/hos-apply-title"
  import VTextarea from "../../components/common/v-textarea"
  import conculFile from "../../components/consultation/concul-file"

  export default {
    name: "disease-dialog",
    props: {
      info: Object
    },
    data() {
      return {
        dialogVisible: false,
        form: {},
      }
    },
    components: {hosApplyTitle, VTextarea, conculFile},
    watch: {
      info: {
        handler(newV) {
          let con = {
            consultContent: newV.consultGroup.consultContent,
            beforeDiagnose: newV.consultGroup.beforeDiagnose,
            consultReason: newV.consultGroup.consultReason,
            status: newV.consultGroup.consultStatus,
          }
          this.$nextTick(()=>{
            this.form = Object.assign({}, this.form, con);
          })
          this.$set(this.form, 'picList', newV.picList);
          this.$set(this.form, 'attaList', newV.attaList);
        },
        deep: true
      },
    },
    methods: {
      show(id) {
        this.dialogVisible = true;
      },
      hide() {
        this.dialogVisible = false;
      },
      handleClose() {
        this.$emit('close')
      },
    },
  }
</script>

<style scoped>

</style>
